import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import Mm10010View from "../../Views/Manufacture/MM10010";
import Snackbar from "../../Components/Snackbar";
import { useNavigate } from "react-router-dom";
function MM10010(props) {
  const navigate = useNavigate();
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [rowData1, setRowData1] = React.useState([]);
  const [itemRowData, setItemRowData] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [changedRowData1, setChangedRowData1] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [selectedRowData1, setSelectedRowData1] = React.useState([]);
  const [selectedItemRowData, setSelectedItemRowData] = React.useState([]);
  const [columnDefs, setColumnDefs] = React.useState([]);
  const [columnDefs1, setColumnDefs1] = React.useState([]);
  const today = new Date();
  const newDay = new Date();
  const today1 = new Date();
  const newDay1 = new Date();
  const [inputs, setInputs] = React.useState({
    startDate: new Date(newDay.setDate(today.getDate() + 1)),
    endDate: new Date(newDay1.setDate(today1.getDate() + 7)),
    plantCd: "",
  });
  let checkRowData = [];
  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const CreateColumnDefs = (_endDate = inputs.endDate) => {
    let resultArr = [
      {
        field: "no",
        headerName: "No",
        minWidth: 110,
        headerCheckboxSelection: true,
        checkboxSelection: true,
      },
      { field: "plantCd", headerName: "사업자코드" },
      { field: "itemCd", headerName: "품목코드" },
      {
        field: "itemNm",
        headerName: "품목명",
        cellStyle: { textAlign: "center" },
      },
      {
        field: "itemStd1",
        headerName: "규격",
        cellStyle: { textAlign: "center" },
      },
    ];
    let diffDate = Commons.DateDiff(
      Commons.DateFormating(inputs.startDate),
      Commons.DateFormating(_endDate)
    );

    for (let i = 0; i < diffDate + 1; i++) {
      let someDay = inputs.startDate;
      let year = someDay.getFullYear();
      let month = someDay.getMonth() + 1;
      let day = someDay.getDate() + i;

      resultArr.push({
        field: "planQty" + i.toString(),
        headerName:
          year +
          "-" +
          month.toString().padStart(2, "0") +
          "-" +
          day.toString().padStart(2, "0"),
        cellDataType: "number",
        editable: true,
      });
    }
    setColumnDefs(resultArr);
  };

  const Init = async (_endDate = inputs.endDate, _type) => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let resultColArr = [
      // {
      // 	field: "no",
      // 	headerName: "No",
      // 	minWidth: 110,
      // 	checkboxSelection: true,
      // },
      { field: "plantCd", headerName: "사업자코드", hide: true },
      {
        field: "itemCd",
        headerName: "품목코드",
        checkboxSelection: true,
      },
      {
        field: "itemNm",
        headerName: "품목명",
        minWidth: 300,
      },
      {
        field: "itemStd1",
        headerName: "규격",
        cellStyle: { textAlign: "center" },
      },
    ];
    let resultColArr1 = [
      // {
      // 	field: "no",
      // 	headerName: "No",
      // 	minWidth: 110,
      // },
      { field: "bomItemCd", headerName: "품목코드" },
      {
        field: "itemNm",
        minWidth: 300,
        headerName: "품목명",
      },
      {
        field: "itemStd",
        headerName: "규격",
        cellStyle: { textAlign: "center" },
      },
    ];
    let resultRowData = [];
    let diffDate = Commons.DateDiff(
      Commons.DateFormating(inputs.startDate),
      Commons.DateFormating(_endDate)
    );

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetItemList3,
        {
          plantCd: "string",
          itemType: "ITEM_TYPE_01",
          value: "string",
        }
      ).then((result) => {
        let data = result.data;
        setItemRowData(data);
      });

      for (let i = 0; i < diffDate + 1; i++) {
        const today1 = new Date();
        const newDay1 = new Date();
        const today2 = new Date(newDay1.setDate(today1.getDate() + 1));
        const newDay2 = new Date(newDay1.setDate(today1.getDate() + 1));
        let someDay = new Date(newDay2.setDate(today2.getDate() + i));

        let year = someDay.getFullYear();
        let month = someDay.getMonth() + 1;
        let day = someDay.getDate();
        resultColArr.push({
          field: "planQty" + i.toString(),
          headerName:
            year +
            "-" +
            month.toString().padStart(2, "0") +
            "-" +
            day.toString().padStart(2, "0"),
          editable: true,

          valueFormatter: (params) => {
            var formatted = params.value
              ? params.value
                  .toString()
                  .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
              : "";
            return formatted;
          },
          cellStyle: { textAlign: "right" },
        });

        resultColArr1.push({
          cellStyle: { textAlign: "right" },
          field:
            year +
            "-" +
            month.toString().padStart(2, "0") +
            "-" +
            day.toString().padStart(2, "0"),
          headerName:
            year +
            "-" +
            month.toString().padStart(2, "0") +
            "-" +
            day.toString().padStart(2, "0"),
          editable: false,
          valueFormatter: (params) => {
            var formatted = params.value
              ? params.value
                  .toString()
                  .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
              : "";
            return formatted;
          },
          cellStyle: (params) => {
            let paramsSplit = null;
            if (params.value) {
              paramsSplit = params.value.toString().split(" ");
              if (paramsSplit.length > 1 && paramsSplit[0] * 1 < 0) {
                return { color: "red", textAlign: "right" };
              }
            }
          },
        });
      }
      setColumnDefs(resultColArr);
      setColumnDefs1(resultColArr1);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10010.GetManuFacturePlan,
        {
          startDate: Commons.DateFormating(inputs.startDate),
          endDate: Commons.DateFormating(_endDate),
        }
      ).then((result) => {
        let data = result.data;
        let getRowData = [];
        checkRowData.push(data);
        if (data === "데이터가 없습니다.") {
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          if (!_type) {
            setSnackbars({
              toggle: true,
              type: "success",
              message: "조회되었습니다.",
            });
          }

          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              plantCd: data[i].plantCd,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemStd1: data[i].itemStd1,
              planDateTime0: data[i].planDateTime0,
              planDateTime1: data[i].planDateTime1,
              planDateTime2: data[i].planDateTime2,
              planDateTime3: data[i].planDateTime3,
              planDateTime4: data[i].planDateTime4,
              planDateTime5: data[i].planDateTime5,
              planDateTime6: data[i].planDateTime6,
              planQty0: data[i].planQty0
                ? data[i].planQty0.toString()
                : data[i].planQty0,
              planQty1: data[i].planQty1
                ? data[i].planQty1.toString()
                : data[i].planQty1,
              planQty2: data[i].planQty2
                ? data[i].planQty2.toString()
                : data[i].planQty2,
              planQty3: data[i].planQty3
                ? data[i].planQty3.toString()
                : data[i].planQty3,
              planQty4: data[i].planQty4
                ? data[i].planQty4.toString()
                : data[i].planQty4,
              planQty5: data[i].planQty5
                ? data[i].planQty5.toString()
                : data[i].planQty5,
              planQty6: data[i].planQty6
                ? data[i].planQty6.toString()
                : data[i].planQty6,
            });
          }
          setRowData(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        navigate("/");

        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SaveConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        CreateManuFacturePlan();
      }
    );
  };

  const CreateManuFacturePlan = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let updateData = Commons.Deduplication(changedRowData);
    let filterArr = [];
    let pushData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      for (let i = 0; i < updateData.length; i++) {
        pushData.push({
          plantCd: inputs.plantCd,
          itemCd: updateData[i].itemCd,
          itemNm: updateData[i].itemNm,
          itemStd1: updateData[i].itemStd1,
          newYn: updateData[i].newYn,
          planDateTime0: columnDefs[4] ? columnDefs[4].headerName : new Date(),
          planDateTime1: columnDefs[5] ? columnDefs[5].headerName : new Date(),
          planDateTime2: columnDefs[6] ? columnDefs[6].headerName : new Date(),
          planDateTime3: columnDefs[7] ? columnDefs[7].headerName : new Date(),
          planDateTime4: columnDefs[8] ? columnDefs[8].headerName : new Date(),
          planDateTime5: columnDefs[9] ? columnDefs[9].headerName : new Date(),
          planDateTime6: columnDefs[10]
            ? columnDefs[10].headerName
            : new Date(),
          planQty0: updateData[i].planQty0,
          planQty1: updateData[i].planQty1,
          planQty2: updateData[i].planQty2,
          planQty3: updateData[i].planQty3,
          planQty4: updateData[i].planQty4,
          planQty5: updateData[i].planQty5,
          planQty6: updateData[i].planQty6,
          userId: userInfo.userId,
        });
      }

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10010.CreateManuFacturePlan,
        pushData
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            typ: "error",
            message: data,
          });
          setChangedRowData([]);
        } else {
          setChangedRowData([]);
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const DeleteConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        DeleteManuFacturePlan();
      }
    );
  };

  const DeleteManuFacturePlan = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let pushData = [];
    let diffDate = Commons.DateDiff(
      Commons.DateFormating(inputs.startDate),
      Commons.DateFormating(inputs.endDate)
    );
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      selectedRowData.map((item, index) => {
        let objKeys = Object.keys(item);
        let objValues = Object.values(item);

        for (let i = 0; i < objValues.length - 1; i++) {
          if (
            objValues[i]
              ? objValues[i].substring(0, 2) === "20"
              : "" && objValues[i]
          ) {
            pushData.push({
              plantCd: item.plantCd,
              itemCd: item.itemCd,
              planDt: objValues[i].substring(0, 10),
              planQty: objValues[i + diffDate + 1] * 1,
              createId: userInfo.userId,
              createDate: new Date(),
              updateId: userInfo.userId,
              updateDate: new Date(),
            });
          }
        }
      });

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10010.DeleteManuFacturePlan,
        pushData
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const CalcularConfirm = () => {
    Dialog.Confirm(
      "계산",
      "계산하시겠습니까?",
      "계산",
      () => {
        GetStockCal();
      },
      "취소"
    );
  };

  const GetStockCal = async () => {
    Dialog.ProgressBar(true);
    let resultRowData = [];
    let diffDate = Commons.DateDiff(
      Commons.DateFormating(inputs.startDate),
      Commons.DateFormating(inputs.endDate)
    );
    let checkLength;
    let checkLength1;
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10010.GetStockCal,
        {
          itemCd: selectedRowData[0].itemCd,
        }
      ).then((result) => {
        let data = result.data;
        let filterArr = [];
        let filterArr1 = [];
        filterArr1 = checkRowData.filter(
          (f) => f.itemCd === selectedItemRowData[0].itemCd
        );
        if (data === "데이터가 없습니다.") {
          setRowData1([]);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          setSnackbars({
            toggle: true,
            type: "success",
            message: "계산되었습니다.",
          });

          for (let i = 0; i < data.length; i++) {
            if (i === data.length - 1) {
              filterArr.push(data[i]);
              break;
            } else if (data[i].bomItemCd !== data[i + 1].bomItemCd) {
              filterArr.push(data[i]);
            }
          }
          filterArr.map((item, index) => {
            let assignObj = [];
            let equalItems = data.filter((f) => f.bomItemCd === item.bomItemCd);
            checkLength = equalItems;
            for (let i = 0; i < equalItems.length; i++) {
              let createStr =
                '{ "plantCd": "' +
                item.plantCd +
                '", "bomItemCd": "' +
                item.bomItemCd +
                '","itemNm": "' +
                item.itemNm +
                '", "itemStd": "' +
                (item.itemStd ? item.itemStd : "") +
                '",';
              for (let j = 0; j < diffDate + 1; j++) {
                const today1 = new Date();
                const newDay1 = new Date();
                const today2 = new Date(newDay1.setDate(today1.getDate() + 1));
                const newDay2 = new Date(newDay1.setDate(today1.getDate() + 1));
                let someDay = new Date(newDay2.setDate(today2.getDate() + j));
                let year = someDay.getFullYear();
                let month = someDay.getMonth() + 1;
                let day = someDay.getDate();

                if (j === diffDate) {
                  if (
                    year +
                      "-" +
                      month.toString().padStart(2, "0") +
                      "-" +
                      day.toString().padStart(2, "0") ===
                    equalItems[i].planDt
                  ) {
                    createStr =
                      createStr +
                      '"' +
                      year +
                      "-" +
                      month.toString().padStart(2, "0") +
                      "-" +
                      day.toString().padStart(2, "0") +
                      '": "' +
                      equalItems[i].usedQty +
                      '"';
                  } else {
                    createStr =
                      createStr +
                      '"' +
                      year +
                      "-" +
                      month.toString().padStart(2, "0") +
                      "-" +
                      day.toString().padStart(2, "0") +
                      '": ""';
                  }
                } else {
                  if (
                    year +
                      "-" +
                      month.toString().padStart(2, "0") +
                      "-" +
                      day.toString().padStart(2, "0") ===
                    equalItems[i].planDt
                  ) {
                    createStr =
                      createStr +
                      '"' +
                      year +
                      "-" +
                      month.toString().padStart(2, "0") +
                      "-" +
                      day.toString().padStart(2, "0") +
                      '": "' +
                      equalItems[i].usedQty +
                      '",';
                  }
                }
              }
              createStr = createStr + "}";
              assignObj.push(JSON.parse(createStr));
            }
            resultRowData.push(Object.assign({}, ...assignObj));
          });
          let rowData = [];
          for (let i = 0; i < filterArr.length; i++) {
            rowData.push(resultRowData[i]);
          }
          setRowData1(rowData);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  return (
    <>
      <Mm10010View
        Init={Init}
        columnDefs={columnDefs}
        columnDefs1={columnDefs1}
        rowData={rowData}
        setRowData={setRowData}
        rowData1={rowData1}
        setRowData1={setRowData1}
        itemRowData={itemRowData}
        setItemRowData={setItemRowData}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        selectedRowData={selectedRowData}
        setSelectedRowData={setSelectedRowData}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        selectedItemRowData={selectedItemRowData}
        setSelectedItemRowData={setSelectedItemRowData}
        inputs={inputs}
        setInputs={setInputs}
        SaveConfirm={SaveConfirm}
        DeleteConfirm={DeleteConfirm}
        CalcularConfirm={CalcularConfirm}
        // CreateColumnDefs={CreateColumnDefs}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default MM10010;
